import WebContext from "@/scripts/Contexts/WebContext";
import { useContext } from "react";
import { WebGlobal } from "./useWebGlobal";

export default function useWeb(): WebGlobal {
  const web = useContext(WebContext);

  return web;
}
